import type { ID } from '@octopus-do/octopus-project-core'

const TOOLBAR_SELECTOR = '[data-arrow-toolbar]'

/** The toolbar lives in a portal, so a click on it is outside its arrow in the DOM. */
export const isInsideArrowToolbar = (target: EventTarget | null): boolean =>
  target instanceof Element && target.closest(TOOLBAR_SELECTOR) !== null

/** The label of the arrow, if it has one; its plate is the only one with a position. */
export const getArrowLabel = (id: ID): Element | null =>
  document.querySelector(`[data-position][data-arrow-id="${id}"]`)

/** A click on the arrow's own label keeps the arrow selected: the second one edits it. */
export const isInsideArrowLabel = (
  id: ID,
  target: EventTarget | null
): boolean => {
  const label = getArrowLabel(id)

  return !!label && target instanceof Node && label.contains(target)
}
